<button
  [type]="type"
  [disabled]="disabled"
  [loading]="loading"
  [class.full-width]="fullWidth"
  [style.width]="fullWidth ? '100%' : width"
  class="primary-button"
  (click)="onClick()"
>
  <span class="button-text">{{ text }}</span>
</button>

